import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import moment from 'moment';
import {Formatter, SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

export default class SaleSearch extends BaseModel {
  sale_no = null;
  title = null;
  description = null;
  currency_uuid = null;
  type = null;
  department_uuid = null;
  is_published = null;
  is_after_sale = null;
  status = [];
  dateRange = {startDate: null, endDate: null};
  live_reference = null;
  is_private = null;
  buyer_group_account = null;
  vendor_group_account = null;

  rules = {};

  attributeLabels = {
    sale_no: i18n.t('Sale No'),
    title: i18n.t('Title'),
    description: i18n.t('Description'),
    currency_uuid: i18n.t('Currency'),
    type: i18n.t('Type'),
    department_uuid: i18n.t('Department'),
    is_published: i18n.t('Published'),
    is_listed: i18n.t('Listed'),
    status: i18n.t('Status'),
    live_reference: i18n.t('Live Auctions ref.'),
    is_after_sale: i18n.t('After Sale'),
    is_private: i18n.t('Private Sales only'),
    buyer_group_account: i18n.t('Buyer Group Account'),
    vendor_group_account: i18n.t('Vendor Group Account')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (this.dateRange.startDate) {
      data.date_after = moment(this.dateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.dateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    delete data.department;
    delete data.dateRange;

    if (data.is_published || data.is_listed) {
      if (data.is_published && data.is_listed) {
        data.status_in = 'published,listed';
      } else if (data.is_published) {
        data.status_in = 'published';
      } else if (data.is_listed) {
        data.status_in = 'listed';
      }
      delete data.is_listed
      delete data.is_published
    }

    data.is_after_sale ? data.is_after_sale = 'true' : data.is_after_sale = 'false'
    data.is_private = data.is_private ? 'true' : null

    data.status = data.status.join(',')
    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        if (attr === 'department_uuid') {
          value = _.capitalize(Formatter.getByMasterLanguage(this.department.name));
        }

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(SaleSearch);
